import { Link } from "react-router-dom";

// Rainbow gradient wordmark logo.
const Logo = ({ className = "", stacked = false, onClick }) => (
  <Link
    to="/"
    onClick={onClick}
    className={`display uppercase leading-[0.82] tracking-tight ${className}`}
    data-testid="logo"
    aria-label="Anti Unhealthy Club home"
  >
    <span className="text-brand">
      {stacked ? (
        <>
          Anti<br />Unhealthy<br />Club
        </>
      ) : (
        "Anti Unhealthy Club"
      )}
    </span>
  </Link>
);

export default Logo;
